import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { BankOutlined, ShopOutlined, UserOutlined, BarChartOutlined } from '@ant-design/icons';
import './FacilityDashboardPage.css';

const FacilityDashboardPage: React.FC = () => {
  return (
    <div className="facility-dashboard-page">
      <h1>Dashboard</h1>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Tổng số CSYT"
              value={112}
              prefix={<BankOutlined />}
              valueStyle={{ color: '#385da4' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Nhà cung cấp"
              value={45}
              prefix={<ShopOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Tổng số User"
              value={256}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Hoạt động"
              value={98}
              suffix="%"
              prefix={<BarChartOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default FacilityDashboardPage;
